module.exports = __webpack_public_path__ + "img/source6.9efd8bb6.png";